import { Component, Input} from '@angular/core';
import { LoadingController, NavController, ToastController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';

import { ResultListModel, ResultProvider } from '../../providers/result/result';
import { PublicProfileModel, UserProvider } from '../../providers/user/user';
import { LoaderProvider } from '../../providers/loader/loader';
import { ValueModel, ValueProvider } from '../../providers/value/value';
import { SessionProvider } from '../../providers/session/session';
import { ConfigProvider } from '../../providers/config/config';
import { NewsController } from '../../providers/news/news-contoller';
import { Router } from '@angular/router';

/**
 * Generated class for the ResultSearchListItemComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'result-search-list-item',
  templateUrl: 'result-search-list-item.html',
  styleUrls:['./result-search-list-item.scss']
})
export class ResultSearchListItemComponent {
  @Input('result')
  result: ResultListModel;
  color = 'dark';

  @Input('displayHead')
  displayHead: boolean = true;
  commentButton: boolean = false;

  @Input('userSection')
  userSection: boolean = false;

  constructor(
    public router:Router,
    public translate: TranslateService,
    private loadingCtrl: LoadingController,
    private resultService: ResultProvider,
    private userService: UserProvider,
    private toastCtrl: ToastController,
    public valueService: ValueProvider,
    private sessionService: SessionProvider,
    private config: ConfigProvider,
    private navCtrl:NavController
  ) {
    this.fetchConfig();
    console.log('results-search-list-item')
  }

  async fetchConfig() {
    new Promise(async (resolve, reject) => {
      this.commentButton = (await this.config.config).showHide.tabsToolbarButtons;
    });
  }

  showResult() {
    NewsController.getInstance().isAllowed = false;
    this.navCtrl.navigateForward('/result-details', {state:{result: this.result, userSection: this.userSection}})

    // this.app.getRootNav().push(ResultDetailsPage, { result: this.result, userSection: this.userSection });
  }

  async showSportProfile() {
    let loader = await this.loadingCtrl.create({ message: this.translate.instant('GLOBAL_LOADING') });
    loader.present();
    setTimeout(()=>{loader.dismiss()},3000)
  }

  async showRanglist(model: ResultListModel) {
    let loader = await this.loadingCtrl.create({ message: this.translate.instant('GLOBAL_LOADING') });
    loader.present();

    let searchModel = { eid: '' + model.eventId, ename: '' + model.eventName, limit: 25 + '', page: 1 + '', start: 0 + '' };
    console.log('SEARCH MODE !!!!!! ');
    console.log(searchModel);

    this.resultService.getRangList(searchModel).then(data => {
      console.log(data);
      this.navCtrl.navigateForward('/result-ranglist', {state:{data: { list: data, search: searchModel}}}).then(() => loader.dismiss());
      // (this.app.getRootNav() as NavController).push(ResultRanglistPage, { data: { list: data, search: searchModel } }).then(() => loader.dismiss());
    });
  }


  // for Events App
  async onCongrat() {
    await this.sessionService.getToken(false, false)
    this.navCtrl.navigateForward('/result-details-tabs', {state:{result: this.result}});
    // this.app.getRootNav().push(ResultDetailsTabsPage, { result: this.result });
  }

  // for Hannover app and others
  async congrat() {
    let loader = await this.loadingCtrl.create({ message: this.translate.instant('GLOBAL_LOADING') });
    loader.present();
    this.resultService.congrat(this.result.id).then(succ => {
      if (succ) {
        this.color = 'primary';
        this.toastCtrl
          .create({
            message: this.translate.instant('TOAST_CONGRATULATED'),
            duration: 3000,
            buttons:[{text:'OK', role:"cancel"}]
          }).then(toast=>toast.present());
      } else {
        this.toastCtrl
          .create({
            message: this.translate.instant('TOAST_UNKNOWN_ERROR'),
            duration: 3000,
            buttons:[{text:'OK', role:"cancel"}]
          }).then(toast=>toast.present());
      }
      loader.dismiss();
    });
  }
}
